export default function Sass_Numeric() {
  return (
    <div>
      <h1>Sass Numeric</h1>
    </div>
  );
}
